<header class="article-header">
  <div class="article-header__breadcrumb">
    <app-breadcrumb [items]="breadcrumbs()" />
  </div>

  <div class="article-header__hero">
    <img
      class="article-header__image"
      [src]="post().imageUrl"
      [alt]="post().imageAlt || post().title"
      [width]="post().imageWidth"
      [height]="post().imageHeight"
    />
    <div
      class="article-header__overlay"
      [style.--hero-accent]="post().game.accentColor"
    ></div>

    <div class="article-header__content">
      <div class="article-header__badges">
        <a
          class="article-header__game-badge"
          [style.background-color]="post().game.accentColor"
          [routerLink]="['/blog']"
          [queryParams]="{ game: post().game.slug }"
        >{{ post().game.name }}</a>
        @for (cat of post().categories; track cat.id) {
          <a
            class="article-header__cat-badge"
            [routerLink]="['/blog']"
            [queryParams]="{ category: cat.slug }"
          >{{ cat.name }}</a>
        }
      </div>

      <div class="article-header__meta">
        <time [attr.datetime]="post().publishedAt">{{ post().publishedAt | blogDate }}</time>
        <span>&middot;</span>
        <span>{{ post().readTimeMinutes | blogReadTime }}</span>
      </div>

      <h1 class="article-header__title">{{ post().title }}</h1>

      <div class="article-header__author">
        <img
          class="article-header__avatar"
          [src]="post().authorAvatarUrl"
          [alt]="post().authorName"
          width="40"
          height="40"
          loading="lazy"
        />
        <div class="article-header__author-info">
          <span class="article-header__author-name">{{ post().authorName }}</span>
          <span class="article-header__author-role">{{ post().authorRole }}</span>
        </div>
      </div>
    </div>
  </div>
</header>
